import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  expand(div:Element){
    let elems = document.getElementsByClassName('footer-block');
    for (let i=0;i<elems.length;i++){
      elems[i].classList.add('collapsed-mobile');
    }
    div.classList.remove("collapsed-mobile");
  }
}
